/**
 * CrmProspectingWidget — the firm-wide "are we bringing in new work" pill, mounted in
 * CrmWorkspace.jsx's shared header so it's visible from every CRM tab, not just one. Tracks
 * outbound prospecting (new-business outreach that hasn't become a tracked Lead yet) separately
 * from working leads/opportunities already in the system — the whole point is a signal that
 * doesn't go quiet just because the existing pipeline looks fine. No per-rep ownership; a shared,
 * firm-wide weekly count vs. WEEKLY_PROSPECTING_TARGET (services/prospecting.js).
 */
import { useEffect, useState } from 'react'
import { getWeeklyProspectingStatus } from '../../services/prospecting.js'
import CrmLogInteractionModal from './CrmLogInteractionModal.jsx'

const PACE_COLOR = { ahead: '#1D9E75', onpace: '#2B7A9E', behind: '#BA7517' }
const PACE_LABEL = { ahead: 'On track', onpace: 'On pace', behind: 'Behind pace' }

export default function CrmProspectingWidget() {
  const [status, setStatus] = useState(null)
  const [logOpen, setLogOpen] = useState(false)

  function load() { getWeeklyProspectingStatus().then(setStatus).catch(() => {}) }
  useEffect(() => { load() }, [])

  if (!status) return null
  const color = PACE_COLOR[status.status] || PACE_COLOR.onpace

  return (
    <>
      <button
        style={{ ...S.pill, color, borderColor: color + '55', background: color + '14' }}
        onClick={() => setLogOpen(true)}
        title={`${PACE_LABEL[status.status]} — ${status.count} of ${status.target} new-outreach touches logged this week. Click to log one.`}
      >
        New outreach {status.count}/{status.target}
      </button>
      {logOpen && (
        <CrmLogInteractionModal title="Log outreach" onClose={() => setLogOpen(false)}
          onLogged={() => { setLogOpen(false); load() }} />
      )}
    </>
  )
}

const S = {
  pill: {
    fontFamily: '"DM Sans", sans-serif', fontSize: 11.5, fontWeight: 600, border: '0.5px solid',
    borderRadius: 20, padding: '5px 12px', cursor: 'pointer', marginLeft: 4,
  },
}
